import { IAddressDetailMobSiteSchema } from '../../types/recommendation';

const REGION_PART_KEYS = new Set(['city', 'location', 'region']);
const SERVICE_GEO_PART_KEYS = new Set([
  'area',
  'district',
  'metro',
  'okrug',
  'raion',
  'railway',
  'subdistrict',
  'underground',
]);

function normalizeAddressPart(value: string): string {
  return value.trim();
}

function normalizeRegionPart(value: string): string {
  return normalizeAddressPart(value)
    .replace(/^г\.?\s+/i, '')
    .replace(/^город\s+/i, '')
    .replace(/автономный округ/gi, 'АО')
    .replace(/автономная область/gi, 'АО')
    .replace(/область/gi, 'обл.')
    .replace(/республика/gi, 'респ.')
    .replace(/край/gi, 'кр.');
}

function isRegionAddressPart({ key }: IAddressDetailMobSiteSchema): boolean {
  return REGION_PART_KEYS.has(key);
}

function isServiceGeoAddressPart({ key }: IAddressDetailMobSiteSchema): boolean {
  return SERVICE_GEO_PART_KEYS.has(key);
}

function getAddressParts(data: IAddressDetailMobSiteSchema[]): string[] {
  const result: string[] = [];
  const usedParts = new Set<string>();

  data.forEach(item => {
    if (isRegionAddressPart(item) || isServiceGeoAddressPart(item)) {
      return;
    }

    const normalizedPart = normalizeAddressPart(item.value);

    if (!normalizedPart || usedParts.has(normalizedPart)) {
      return;
    }

    usedParts.add(normalizedPart);
    result.push(normalizedPart);
  });

  return result;
}

export function redesignedAddressToString(data: IAddressDetailMobSiteSchema[]): string {
  const addressParts = getAddressParts(data);
  const regionParts = new Set(
    data
      .filter(isRegionAddressPart)
      .map(({ value }) => normalizeRegionPart(value))
      .filter(Boolean),
  );

  return [...regionParts, ...addressParts].join(', ');
}
